import { render, staticRenderFns } from "./leituras.vue?vue&type=template&id=0d27b2b2&scoped=true&"
import script from "./leituras.vue?vue&type=script&lang=ts&"
export * from "./leituras.vue?vue&type=script&lang=ts&"
import style0 from "./leituras.vue?vue&type=style&index=0&id=0d27b2b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d27b2b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
